export default __webpack_public_path__ + "static/media/unknown.1decfc21.png";